export default function AppLoading() {
    return (
        <div className="fixed inset-0 z-50 bg-gray-900 bg-opacity-90 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
    );
}
